import React, { useContext, createContext } from 'react'
import { useIsDesktop, useIsMobile } from '../../hooks/useMediaQuery'
import usePersistState from '../../hooks/usePersistState'
import { ReminderProvider } from './ReminderDialog'

const DashboardContext = createContext()

export const useDashboard = () => {
  return useContext(DashboardContext)
}

export const DashboardProvider = ({ current_user, children }) => {
  const isMobile = useIsMobile()
  const isDesktop = useIsDesktop()

  const candidateId = current_user.candidate_id
  const locale = current_user.locale || 'en'

  const [onlyReminders, setOnlyReminders] = usePersistState(
    false,
    'onlyReminders',
  )

  const value = {
    current_user,
    isDesktop,
    isMobile,
    onlyReminders,
    setOnlyReminders,
  }

  const reminderValue = {
    candidateId,
    locale,
  }

  return (
    <DashboardContext.Provider value={value}>
      <ReminderProvider {...reminderValue}>{children}</ReminderProvider>
    </DashboardContext.Provider>
  )
}
